module.exports = __webpack_public_path__ + "img/info-icon.7a022558.svg";